'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function (layout, metaData, dashboard) {
    return _extends(getTextObject(layout, metaData, dashboard), DEFAULT_TITLE_STYLE, dashboard ? DASHBOARD_TITLE_STYLE : undefined);
};

var _isString = require('d2-utilizr/lib/isString');

var _isString2 = _interopRequireDefault(_isString);

var _getFilterTitle = require('./getFilterTitle');

var _getFilterTitle2 = _interopRequireDefault(_getFilterTitle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_TITLE_STYLE = {
    margin: 30,
    y: 18,
    style: {
        color: '#111'
    }
};

var DASHBOARD_TITLE_STYLE = {
    margin: 15,
    y: 12,
    style: {
        fontSize: '13px',
        fontWeight: 'bold'
    }
};

function getText(layout, metaData, dashboard) {

    // title
    if ((0, _isString2.default)(layout.title) && layout.title.length) {
        return layout.title;
    }

    // name - REMOVED: APPS SHOULD HANDLE THIS
    // if (dashboard && (isString(layout.name) && layout.name.length)) {
    //     return layout.name;
    // }

    // filters
    if (layout.filters && !dashboard) {
        return (0, _getFilterTitle2.default)(layout.filters, metaData);
    }

    return null;
}

function getTextObject(layout, metaData, dashboard) {
    return {
        text: layout.hideTitle ? null : getText(layout, metaData, dashboard)
    };
}

;
//# sourceMappingURL=title.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-charts-api/lib/config/adapters/dhis_highcharts/title.js
 ** module id = 206
 ** module chunks = 0 1
 **/